import type { EditorAPI } from '@/editorAPI';

function isPasteEnabled(editorAPI: EditorAPI) {
  return (
    editorAPI.clipboard.hasItem() &&
    editorAPI.isDesktopEditor() &&
    !editorAPI.components.layout.isPinned(
      editorAPI.selection.getSelectedComponents(),
    )
  );
}

export { isPasteEnabled };
